/**
 * Custom logger utility.
 * Wraps console methods and is automatically stripped in production
 * via Vite's import.meta.env.PROD guard.
 *
 * Usage: import { logger } from '@/utils/logger';
 *        logger.info('message', { context });
 */

const IS_DEV = !import.meta.env.PROD;

type LogArgs = unknown[];

function noop(..._args: LogArgs): void {
  // intentionally empty; production no-op
}

export const logger = {
  info: noop,
  warn: IS_DEV ? (...args: LogArgs) => console.warn('[WARN]', ...args) : noop,
  error: IS_DEV ? (...args: LogArgs) => console.error('[ERROR]', ...args) : noop,
  debug: IS_DEV ? (...args: LogArgs) => console.debug('[DEBUG]', ...args) : noop,
};
